import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '../../services/api.service';

@Component({
    selector: 'app-sales-installation-partner-form',
    imports: [CommonModule, FormsModule],
    templateUrl: './sales-installation-partner-form.component.html',
    styleUrls: ['../../lead-management/lead-management.shared.css']
})
export class SalesInstallationPartnerFormComponent implements OnInit {
  isEdit = false;
  partnerId: number | null = null;
  saving = false;
  model: any = {
    company_name: '',
    contact_person: '',
    mobile_number: '',
    alternate_mobile_number: '',
    email: '',
    city: '',
    state: '',
    address: '',
    gst_number: '',
    business_type: '',
    service_areas: '',
    status: 'LEAD',
    notes: '',
    default_commission_type: '',
    default_commission_value: null,
    default_margin_percentage: null,
  };

  businessTypes = [
    ['CCTV_VENDOR', 'CCTV Vendor'],
    ['SECURITY_INTEGRATOR', 'Security Integrator'],
    ['IT_VENDOR', 'IT Vendor'],
    ['HARDWARE_INSTALLER', 'Hardware Installer'],
    ['SYSTEM_INTEGRATOR', 'System Integrator'],
    ['OTHER', 'Other'],
  ];

  statuses = [
    ['LEAD', 'Lead'],
    ['DEMO_SCHEDULED', 'Demo Scheduled'],
    ['DEMO_COMPLETED', 'Demo Completed'],
    ['INTERESTED', 'Interested'],
    ['COMMERCIAL_DISCUSSION', 'Commercial Discussion'],
    ['AGREEMENT_PENDING', 'Agreement Pending'],
    ['ONBOARDED', 'Onboarded'],
    ['ACTIVE', 'Active'],
    ['INACTIVE', 'Inactive'],
    ['REJECTED', 'Rejected'],
  ];

  commissionTypes = [
    ['MARGIN_BASED', 'Margin Based'],
    ['FIXED_COMMISSION', 'Fixed Commission'],
    ['PERCENTAGE_COMMISSION', 'Percentage Commission'],
    ['NOT_APPLICABLE', 'Not Applicable'],
  ];

  constructor(private apiService: ApiService, private route: ActivatedRoute, public router: Router) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      return;
    }
    this.partnerId = Number(id);
    this.isEdit = true;
    this.apiService.getSalesInstallationPartner(this.partnerId).subscribe({
      next: (response: any) => {
        this.model = { ...this.model, ...response };
      }
    });
  }

  save(): void {
    if (!this.model.company_name || !this.model.mobile_number || !this.model.status) {
      return;
    }
    this.saving = true;
    const request = this.isEdit && this.partnerId
      ? this.apiService.updateSalesInstallationPartner(this.partnerId, this.model)
      : this.apiService.createSalesInstallationPartner(this.model);
    request.subscribe({
      next: (response: any) => {
        this.saving = false;
        this.router.navigate(['admin/sales-installation-partners', response.id || this.partnerId]);
      },
      error: () => {
        this.saving = false;
      }
    });
  }
}
